<template>

  <div class="">{{field.label}}</div>
  <q-field
      borderless
      v-model="fieldValue"
      :hide-bottom-space="true"
      :rules="[ (val) => { return !this.field.required || (val && val.length > 0) || this.requiredText }]"
  >
    <template v-slot:control>


      <div>
    <q-radio v-model="fieldValue"  val="Yes" label="Yes" />
    <q-radio v-model="fieldValue"  val="No" label="No" />
      </div>
    </template>
  </q-field>
</template>

<script>
import {mapFields} from "vuex-map-fields";
export default {
  props: {
    modelValue: {},
    field:{},
    hide_bottom_space: null
  },
  data() {
    return {
        test: "Disagreed"
    };
  },
  emits: ['update:modelValue'],
  methods: {

  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
      if(this.fieldValue === undefined || this.fieldValue === null || this.fieldValue === false) {
       // this.fieldValue = 'Disagreed';
      }
  }
}
</script>
